import utils from '@/utils/utils'

// Helpers for partitioning a consolidated DD entry array into its default
// (seeded, fixed-label) and custom (user-added) rows. The `isCustom` flag is
// the single source of truth — defaults seed `false`, custom rows `true`.

export const defaultsOf = (arr) => (arr || []).filter((entry) => !entry.isCustom)
export const customsOf = (arr) => (arr || []).filter((entry) => entry.isCustom)

// Build a camelCase-keyed hash from an array of default entries. Only default
// (non-custom) entries have stable keys; pass `defaultsOf(arr)` if needed.
export function entriesHash(entries) {
  return utils.reduce(
    entries || [],
    (result, entry) => {
      result ||= {}
      result[utils.camelCase(entry.key)] = entry
      return result
    },
    {},
  )
}

// Append a blank custom entry to itemArray (mutates in place).
// opts.showExcluded — also seed isExcluded: false
// opts.groupKey     — set groupKey on the new entry
export function addEntry(itemArray, showExcluded = false, opts = {}) {
  const blank = { key: null, label: null, format: 'currency', val: null, isCustom: true }
  if (showExcluded) blank.isExcluded = false
  if (opts.groupKey) blank.groupKey = opts.groupKey
  itemArray.push(blank)
}

// Remove the entry at idx from itemArray (mutates in place).
export function removeEntry(itemArray, idx) {
  if (idx > -1 && idx < itemArray.length) {
    itemArray.splice(idx, 1)
  }
}

// A null key sums the ungrouped ("Other") entries — those with no groupKey,
// matching how CustomFieldRows partitions them.
export const groupSubtotal = (arr, key) =>
  (arr || [])
    .filter((e) => (key == null ? !e.groupKey : e.groupKey === key) && !e.isExcluded)
    .reduce((sum, e) => sum + (Number(e.val) || 0), 0)
